import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import brandLogo from '../assets/techtennis-logo.png';
import bgImage from '../assets/miami-open-ernesto.jpg';

export const ResetPasswordView = ({ token }: { token: string }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (newPassword.length < 6) {
      setError('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    try {
      const API_URL = import.meta.env.VITE_API_URL || 'https://techtennis-api.vercel.app';
      const response = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao redefinir a senha.');
      }

      setSuccess(true);
      setMessage(data.message || 'Senha atualizada com sucesso!');
    } catch (err: any) {
      setError(err.message || 'Erro de conexão.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '14px', borderRadius: '12px', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.1)', color: 'white', fontSize: '15px'
  };

  return (
    <div style={{ 
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center',
      position: 'relative', padding: '24px'
    }}>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(0,12,60,0.9) 0%, rgba(0,12,60,0.4) 100%)' }}></div>
      
      <div style={{
        background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(24px)', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '24px', padding: '48px', width: '100%', maxWidth: '500px', position: 'relative', zIndex: 10,
        boxShadow: '0 24px 48px rgba(0,0,0,0.5)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src={brandLogo} alt="TechTennis" style={{ height: '90px', mixBlendMode: 'multiply', filter: 'brightness(0) invert(1)' }} />
        </div>

        <h2 style={{ color: 'white', fontSize: '24px', textAlign: 'center', marginBottom: '8px' }}>
          Criar Nova Senha
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.7)', textAlign: 'center', marginBottom: '24px', fontSize: '14px' }}>
          Digite sua nova senha abaixo para recuperar o acesso.
        </p>

        {error && (
          <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid #EF4444', color: '#F87171', padding: '12px', borderRadius: '8px', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
            {error}
          </div>
        )}
        {message && (
          <div style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid #10B981', color: '#34D399', padding: '12px', borderRadius: '8px', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
            {message}
          </div>
        )}

        {!success ? (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', color: 'rgba(255,255,255,0.7)', fontSize: '14px', marginBottom: '8px' }}>Nova Senha</label>
              <div style={{ position: 'relative' }}>
                <input required type={showPassword ? "text" : "password"} value={newPassword} onChange={e => setNewPassword(e.target.value)} style={{ ...inputStyle, paddingRight: '48px' }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', top: '50%', right: '16px', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', color: 'rgba(255,255,255,0.7)', fontSize: '14px', marginBottom: '8px' }}>Confirmar Nova Senha</label>
              <div style={{ position: 'relative' }}>
                <input required type={showPassword ? "text" : "password"} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={{ ...inputStyle, paddingRight: '48px' }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', top: '50%', right: '16px', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            <button disabled={loading} type="submit" className="button-primary" style={{ padding: '16px', fontSize: '16px', fontWeight: 800, marginTop: '8px', background: 'var(--bg-gradient-top)', color: 'white', border: '1px solid rgba(255,255,255,0.2)' }}>
              {loading ? 'Salvando...' : 'Salvar Nova Senha'}
            </button>
          </form>
        ) : (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button onClick={() => window.location.href = '/'} className="button-primary" style={{ padding: '16px', fontSize: '16px', fontWeight: 800, background: 'var(--bg-gradient-top)', color: 'white', border: '1px solid rgba(255,255,255,0.2)', width: '100%' }}>
              Voltar para o Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
